








































































































































































































































































































































































































































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyForm from "@/mixins/form";
import moment from "moment";
import _ from "lodash";

import AreaPicker from "@/components/areapicker.vue";
import TsUpload from "@/components/upload.vue";
import SelectCustomer from "@/components/selectcustomer.vue";
import Amap from "@/components/amap.vue";

import MyConfig from "@/config.ts";
import OnlineSetting from "./components/onlinesetting.vue";

@Component({
  components: {
    AreaPicker,
    TsUpload,
    SelectCustomer,
    Amap,
    OnlineSetting
  }
})
export default class extends Mixins(MyForm) {
  apiserver: string = MyConfig.casapi;

  // @Prop() stadiumId!: number
  @Prop() stadium!: any;
  // @Prop() customerId!: number;
  // @Prop() fromStadiumId!: number;

  customerId = 0;

  fromStadiumId = 0;

  stadiumId = 0;

  customerform!: any;

  licenseform!: any;

  agreementform!: any;

  formData1: any = {};

  formData2: any = {};

  submitable = false;

  submitable1 = false;

  submitable2 = false;

  current = 0;

  amapcity: any = "";
  amapaddr: any = "";

  steps: any[] = [
    // { title: '选择场馆主体' },
    { title: "场馆基本信息" },
    { title: "场馆经营资质" },
    { title: "入驻服务协议" },
    { title: "上线设置" }
  ];

  headers: any = {
    Authorization: window.localStorage.getItem("token")
  };

  amapcallback(lng: any, lat: any) {
    this.form.setFieldsValue({
      lnglat: `${lng},${lat}`
    });
  }

  addressChange() {
    // console.log("222");
    this.$nextTick(() => {
      // console.log(this.form.getFieldValue("addr"));
      this.amapaddr = this.form.getFieldValue("addr");
      const areastr: string[] = this.form.getFieldValue("areastr");

      this.amapcity = areastr;
    });
  }

  calculationMonth(date: string): number {
    if (date) {
      return Math.abs(moment().diff(moment(date), "months"));
    }
    return 0;
  }

  beforeCreate() {
    this.customerform = this.$form.createForm(this);
    this.licenseform = this.$form.createForm(this);
    this.agreementform = this.$form.createForm(this);
  }

  // 保存场馆基本信息
  handleSubmit(e: any) {
    e.preventDefault();
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        if (!_.isEmpty(this.formData) && this.submitable === false) {
          this.current++;
          return;
        }
        this.$confirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            const values: any = {};
            for (const key in fieldValues) {
              if (_.get(fieldValues, [key])) {
                const fieldValue = _.get(fieldValues, [key]);
                if (fieldValue) {
                  if (moment.isMoment(fieldValue)) {
                    values[key] = moment(fieldValue).format("YYYY-MM-DD HH:mm:ss");
                  } else if (key === "areastr") {
                    const areastr: any = _.get(fieldValues, [key]);

                    _.set(values, [key], areastr);
                    let province_id = 0;
                    let city_id = 0;
                    let county_id = 0;

                    // console.log(this.stadium.stadium_info.areastr)

                    if (areastr.length > 2) {
                      county_id = _.parseInt(_.get(areastr, [2]));
                    }
                    if (areastr.length > 1) {
                      city_id = _.parseInt(_.get(areastr, [1]));
                    }
                    if (areastr.length > 0) {
                      province_id = _.parseInt(_.get(areastr, [0]));
                    }

                    _.set(values, ["province_id"], province_id);
                    _.set(values, ["city_id"], city_id);
                    _.set(values, ["county_id"], county_id);
                  } else {
                    _.set(values, [key], _.get(fieldValues, [key]));
                  }
                }
              }
            }
            // 临时数据

            // 如果原来是空的，说明是新加
            this.formData = values;

            // _.unset(values, 'areastr')
            if (_.get(values, ["province_id"]) === 0 && _.get(values, ["city_id"]) === 0) {
              this.$message.error("省市不能为空");
              return;
            }
            // console.log(values)
            const res = await this.$store.dispatch("stadium/addStadium", {
              customer_id: this.customerId,
              ...values
            });
            if (res && res.Data && res.Data !== "{}") {
              this.stadiumId = res.Data;

              if (_.has(values, "tags")) {
                this.$store.dispatch("stadium/saveStadiumTags", {
                  stadium_id: res.Data,
                  tag_ids: JSON.stringify(values.tags)
                });
              }

              this.$message.success("添加成功");
              this.submitable = false;
              this.current++;
            } else {
              this.submitable = true;
              this.$message.error("添加失败");
            }
          }
        });
      }
    });
  }

  // 场馆经营资质
  handleSubmit1(e: any) {
    e.preventDefault();
    this.licenseform.validateFields((err: any, values: any) => {
      if (!err) {
        if (!_.isEmpty(this.formData1) && this.submitable1 === false) {
          this.current++;
          return;
        }
        this.$confirm({
          title: "确认信息",
          content: "你确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            this.formData1 = { ...values };
            const res = await this.$store.dispatch("stadium/addCertificate", {
              stadium_id: this.stadiumId,
              from_stadium_id: this.fromStadiumId,
              mobile: this.formData.contact_phone,
              customer_id: this.customerId,
              ...values
            });
            if (res && res.Message && res.Message === "success") {
              // this.$message.success(res.Message)
              // 下一步
              this.current++;
              this.submitable1 = false;
            } else {
              this.submitable1 = true;
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }

  // 选择场馆主体
  handleSubmit2(e: any) {
    e.preventDefault();
    this.customerform.validateFields((err: any, values: any) => {
      if (!err) {
        this.confirmLoading = true;
        this.customerId = values.customer_id;
        this.current = 1;
        this.confirmLoading = false;
      }
    });
  }

  normFile(e: any) {
    // console.log(e)
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
    // return this.apkurl
  }

  // 完成协议
  handleSubmit3(e: any) {
    e.preventDefault();
    this.agreementform.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        if (!_.isEmpty(this.formData2) && this.submitable2 === false) {
          this.$message.success("添加完成");
          this.current++;
          return;
        }
        this.$confirm({
          title: "确认信息",
          content: "你确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const values: any = {};
            for (const key in fieldValues) {
              if (_.get(fieldValues, [key])) {
                const fieldValue = _.get(fieldValues, [key]);
                if (moment.isMoment(fieldValue)) {
                  _.set(values, [key], moment(fieldValue).format("YYYY-MM-DD HH:mm:ss"));
                } else {
                  _.set(values, [key], fieldValue);
                }
              }
            }

            this.formData2 = { ...values };

            const res = await this.$store.dispatch("stadium/addAgreement", {
              stadium_id: this.stadiumId,
              ...values
            });
            if (res && res.Message && res.Message === "success") {
              // 下一步
              this.submitable2 = false;
              this.$message.success("添加完成");
              this.current++;
            } else {
              this.submitable2 = true;
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }

  handleSubmit4(e: any) {
    e.preventDefault();
    // this.handleCancel();
    this.$router.push({
      path: "/stadium/active"
    });
  }

  next(e: any) {
    // console.log(this.current)
    if (this.current === 0) {
      // 选择场馆主体
      // this.handleSubmit2()
      // } else if (this.current === 1) {
      // 保存场馆基本信息
      this.handleSubmit(e);
    } else if (this.current === 1) {
      // 保存经营资质
      this.handleSubmit1(e);
    } else if (this.current === 2) {
      this.handleSubmit3(e);
    } else {
      this.current++;
    }
  }

  prev() {
    this.current--;
  }

  handleChange() {}

  handlePreview() {}

  async mounted() {
    const query = { ...this.$route.query };
    if (query.customer_id) {
      this.customerId = Number(query.customer_id);
    }
    if (query.from_stadium_id) {
      this.fromStadiumId = Number(query.from_stadium_id);
    }
    if (this.customerId > 0) {
      // 是要添加连锁店，所以自动获取一下手机号
      const res = await this.$store.dispatch("customer/detail", {
        id: this.customerId
      });
      if (res && res.Data && res.Data !== "{}") {
        // console.log(res.Data)
        this.form.setFieldsValue({
          contact_phone: res.Data.mobile
        });
      }
      // 要获取连锁店经营主体的营业执照
      const res1 = await this.$store.dispatch("enterapply/detail", {
        stadium_id: this.fromStadiumId
      });
      if (res1 && res1.Data && res1.Data !== "{}") {
        this.formData1.business_license = res1.Data.business_license;
        this.formData1.principal_identity_card_person_pic =
          res1.Data.principal_identity_card_person_pic;
        this.formData1.principal_identity_card_pic_contrary =
          res1.Data.principal_identity_card_pic_contrary;
        this.formData1.principal_identity_card_pic_positive =
          res1.Data.principal_identity_card_pic_positive;

        this.submitable1 = true;
      }
    }
  }
}
